import { render, staticRenderFns } from "./card-V.vue?vue&type=template&id=2147cfe8&scoped=true&"
import script from "./card-V.vue?vue&type=script&lang=js&"
export * from "./card-V.vue?vue&type=script&lang=js&"
import style0 from "./card-V.vue?vue&type=style&index=0&id=2147cfe8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147cfe8",
  null
  
)

export default component.exports